module.exports = __webpack_public_path__ + "static/img/main_service.a5a6c03.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/ter/images/main_service.png
// module id = FkMb
// module chunks = 0